import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-5/6 h-[100vh] p-[2%]" }
const _hoisted_2 = { class: "md:flex" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "md:flex gap-4" }
const _hoisted_5 = { class: "w-full mt-6" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "font-bold mr-1" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "font-bold mr-1" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "font-bold mr-1" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "font-bold mr-1" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "font-bold mr-1" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "font-bold mr-1" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "font-bold mr-1" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "font-bold mr-1" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "font-bold mr-1" }
const _hoisted_24 = { class: "w-full mt-6" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "flex gap-4" }

import {useRoute} from "vue-router";
  import {onMounted, ref} from "vue";
  import TablesService from "@/services/tables/tables.service";
  import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
  import RoofCarousel from "@/components/building/view/components/RoofCarousel.vue";
  import {LineChart} from "@/components/ui/chart-line";
  import {File, Calculator, FileCode2, FilePlus, StepBack} from "lucide-vue-next";
  import {Button} from "@/components/ui/button";
  import axios from "axios";
  import CalculationDataDialog from "@/components/roof/CalculationDataDialog.vue";
  import CustomChartTooltip from "@/components/roof/CustomChartTooltip.vue";
  import UploadDocumentDialog from "@/components/building/UploadDocumentDialog.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ViewRoof',
  setup(__props) {

  const route = useRoute();
  let roof: any = ref({})

  const data = ref([]);
  const isCalculationDialogOpen = ref(false);
  const setIsCalculationDialogOpen = (value: any) => {
    isCalculationDialogOpen.value = value;
  };
  const isDocumentDialogOpen = ref(false);
  const setIsDocumentDialogOpen = (value: boolean) => {
    isDocumentDialogOpen.value = value;
  };

  const getExcel = async (id: number) => {

    try {
      const res = await axios.get(process.env.VUE_APP_BASE_API_URL + 'service-order/excel/'+id, {
        headers: {
          Authorization: process.env.VUE_APP_API_KEY
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'report.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Errore nel download del file', error);
    }
  };

  onMounted(async () => {
    const res = await TablesService.getElementById('coverages', route.params.id)
    if (res?.data) {
      roof.value = res.data
      if (roof.value.coverageData && roof.value.coverageData.length > 0) {
        roof.value.groupedCoverageData = roof.value.coverageData.reduce((result: any, currentValue: any) => {
          (result[currentValue['serviceOrder']['id']] = result[currentValue['serviceOrder']['id']] || []).push(currentValue);
          return result;
        }, {})
      }
      data.value = JSON.parse(res.data.rci)
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
        type: "button",
        class: "text-center mb-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Card), { class: "h-[53vh]" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.rci')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), { class: "px-4 w-full h-[85%]" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(LineChart), {
                    data: data.value,
                    index: "date",
                    categories: ['value'],
                    "custom-tooltip": CustomChartTooltip
                  }, null, 8, ["data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(RoofCarousel, {
          "entity-id": _unref(route).params.id,
          entity: "coverages"
        }, null, 8, ["entity-id"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Card), { class: "h-full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5 bg-gray-400" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.info')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('column.name')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('column.code')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('column.description')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('column.installation_year')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).installationYear), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('column.dimensions')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).dimensions), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('column.slope')) + ":", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).slope), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('column.construction_cost')) + " (€):", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).constructionCost), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('column.estimated_life')) + " (" + _toDisplayString(_ctx.$t('column.years')) + "):", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).estimatedLife), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('column.intervention_cost')) + " (€):", 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(roof).interventionCost), 1)
                    ]),
                    _createVNode(_unref(Button), {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'documentsView', params: { entity:'coverages', id: _unref(roof).id } })), ["prevent"])),
                      type: "button",
                      class: "w-full text-center mt-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(File), { class: "mr-2 h-5 w-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('building.document_gallery')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (setIsDocumentDialogOpen(true)), ["prevent"])),
                      type: "button",
                      class: "w-full text-center mt-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FilePlus), { class: "mr-2 h-5 w-5" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_document')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_unref(Card), { class: "h-full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), { class: "p-5 bg-gray-400" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardTitle), { class: "text-lg" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('building.calculation_data')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(CardContent), null, {
                default: _withCtx(() => [
                  (_unref(roof).groupedCoverageData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roof).groupedCoverageData, (data, key) => {
                          return (_openBlock(), _createElementBlock("div", { key: key }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_unref(Button), {
                                onClick: _withModifiers(($event: any) => (setIsCalculationDialogOpen(data[0].serviceOrder.id)), ["prevent"]),
                                type: "button",
                                class: "w-[65%] text-center mt-6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Calculator), { class: "mr-2 h-5 w-5" }),
                                  _createTextVNode(" Dati " + _toDisplayString(_ctx.$t('menu.service_order')) + " del " + _toDisplayString(new Date(data[0].serviceOrder.date).toLocaleDateString()), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(CalculationDataDialog, {
                                "set-open": setIsCalculationDialogOpen,
                                open: isCalculationDialogOpen.value === data[0].serviceOrder.id,
                                object: data
                              }, null, 8, ["open", "object"]),
                              _createVNode(_unref(Button), {
                                onClick: _withModifiers(($event: any) => (getExcel(data[0].serviceOrder.id)), ["prevent"]),
                                type: "button",
                                class: "w-[35%] text-center mt-6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(FileCode2), { class: "mr-2 h-4 w-4" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('table.excel')), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(UploadDocumentDialog, {
      entity: "coverages",
      "entity-id": _unref(route).params.id,
      open: isDocumentDialogOpen.value,
      "set-open": setIsDocumentDialogOpen,
      onEdit: _cache[3] || (_cache[3] = ($event: any) => (setIsDocumentDialogOpen(false)))
    }, null, 8, ["entity-id", "open"])
  ], 64))
}
}

})